/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CropReport } from '../../models/crop-report';
import { CropReportUpdateRequest } from '../../models/crop-report-update-request';

export interface UpdateCropReport$Params {
  cropReportId: string;
  sendEmail?: boolean;
      body: CropReportUpdateRequest
}

export function updateCropReport(http: HttpClient, rootUrl: string, params: UpdateCropReport$Params, context?: HttpContext): Observable<StrictHttpResponse<CropReport>> {
  const rb = new RequestBuilder(rootUrl, updateCropReport.PATH, 'put');
  if (params) {
    rb.path('cropReportId', params.cropReportId, {});
    rb.query('sendEmail', params.sendEmail, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CropReport>;
    })
  );
}

updateCropReport.PATH = '/api/cropreport/{cropReportId}';
